<template>
  <div class="col-md-4 exp-card">
    <div class="card-box" :class="(this.category === 'Les expériences culturelles' || isPhone) ? 'margin-b-main' : ''">
      <div class="card-image">
        <img :src="imageSource" :alt="this.experience.name" @click="isPhone ? openModal() : null" :class="isPhone ? 'clickable-image' : ''" />
      </div>
      <div :class="(this.category === 'Les expériences culturelles' || isPhone) ? 'card-content card-space-content' : 'card-content'">
        <div class="d-flex justify-content-between">
          <h3 class="mb-1" :class="isPhone ? 'merriweather-italic-13 text-title-gray' : 'merriweather-italic-15'">{{ this.experience.name }}</h3>
          <img src="../../images/wishlistOn.svg" alt="Coeur plein" v-if="isIncludeInWishlist()" @click="toggleLike()" />
          <img src="../../images/wishlist.svg" alt="Coeur vide" v-else @click="toggleLike()" />
        </div>
        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p14 mb-0' : 'raleway-bold-p16'">{{ this.experience.catch_phrase }}</p>
        <p class="raleway-reg-p15 show-more-para mb-0" v-if="!isPhone">
          {{ showMore ? this.experience.description : truncatedText(140) }}
          <a class="exp-card-a" href="#" @click.prevent="toggleText">
            {{ showMore ? 'Afficher moins' : 'Afficher plus' }}
          </a>
        </p>
        <div class="address-block" v-if="!isPhone">
          <strong>Où?</strong>
          <p class="mb-0 raleway-reg-p15 clickable-address" @click="showLocationOnMap">{{ this.experience.address }}</p>
        </div>
      </div>
    </div>
    
    <!-- Modal for phone mode -->
    <div v-if="showModal && isPhone" class="modal-overlay" @click="closeModal">
      <div class="modal-content-exp" @click.stop>
        <div class="modal-header-exp">
          <h3 class="modal-title merriweather-italic-15">{{ this.experience.name }}</h3>
          <button class="modal-close" @click="closeModal"><i class="fa fa-close" style="font-size:24px"></i></button>
        </div>
        <div class="modal-body-exp">
          <p class="text-uppercase raleway-bold-p16 mb-2">{{ this.experience.catch_phrase }}</p>
          <p class="raleway-reg-p14 mb-3">{{ this.experience.description }}</p>
          <div class="address-block">
            <strong>Où?</strong>
            <p class="mb-0 raleway-reg-p14 clickable-address" @click="showLocationOnMap">{{ this.experience.address }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetcher from "packs/shared/api.js";

export default {
  name: "CardExperienceCarnet",
  props: ["experience", "user" , "category"],
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      wishlistExp: null,
      showMore: false,
      showModal: false,
      fallbackImage:
        "https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg",
    };
  },
  computed: {
    imageSource() {
      return this.experience.photo_key
        ? this.experience.photo_key
        : this.fallbackImage;
    },
  },
  methods: {
    truncatedText(maxLength) {
      const text = this.experience.description || "";
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },
    toggleText() {
      this.showMore = !this.showMore;
    },
    isIncludeInWishlist() {
      return (
        this.wishlistExp &&
        this.wishlistExp.some((exp) => exp.id === this.experience.id)
      );
    },
    async toggleLike() {
      try {
        if (this.user && Object.keys(this.user).length) {
          const response = await fetcher.patch(`/wishlists/${this.user.id}`, {
            experience_id: this.experience.id,
          });
          this.wishlistExp = response.data.experiences;
        } else {
          this.$root.$emit("openModal");
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    // Fetch user's wishlist
    async fetchWishlist() {
      try {
        if (this.user) {
          const response = await fetcher.get("/wishlists.json");
          this.wishlistExp = response.data.experiences;
        }
      } catch (e) {
        console.error(e);
      }
    },
    openModal() {
      this.showModal = true;
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    },
    closeModal() {
      this.showModal = false;
      document.body.style.overflow = 'auto'; // Restore scrolling
    },
    showLocationOnMap() {
      // Emit event to parent component to show this experience on the map
      this.$emit('showOnMap', this.experience);
    },
  },
  mounted() {
    this.fetchWishlist();
  },
};
</script>

<style scoped>
.card-box {
  position: relative
}

.margin-b-main {
  margin-bottom: 15rem;
}

.card-image {
  height: 374px;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content img {
  cursor:pointer;
  width: 24px;
  height: 22px;

  @media screen and (max-width: 768px) {
    width: 15px;
    height: 13px;    
  }
}

.card-content {
  /* border-top: 0; */
  padding: 1.25rem 0.75rem;
  /* position: absolute; */
  /* right: 0; */
  /* z-index: 99; */
  background: #fff;
  /* top: 13rem; */
  width: 100% !important;
  min-height: 95%;

  @media (max-width: 768px) {
    min-height: fit-content;
  }
}

.card-space-content {
  border-top: 0;
  padding: 1.25rem 0.75rem;
  position: absolute;
  right: 0;
  z-index: 0;
  background: #fff;
  top: 13rem;
  width: 80%  !important;
  min-height: 95%;

  @media (max-width: 768px) {
    min-height: fit-content;
    top: 14rem;
  }
}

.card-content img {
  cursor:pointer;
}

.card-content i {
  position: absolute;
  right: 1rem;
  top: 1.25rem;
  color: gray;
  cursor: pointer;
}

.card-content i.text-danger {
  color: red;
}

.card-content strong {
  padding: 0.625rem 0;
  display: block;
}

@media (max-width: 768px) {
  .card-image {
    height: 304px;
    width: 70vw;

    img {
      height: 304px;
      width: 70vw;
    }
  }
  .card-box {
    margin-bottom: unset;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 70vw;
    padding-right: 20px;
    height: 40vh;
    overflow:hidden;
  }
  .card-content {
    max-width: 242px;
    min-height: 101px;
    max-height: fit-content;
    overflow: hidden;
  }
}

.text-address-gray {
  color: #434343;
}

.text-title-gray {
  color: #3B3B3B;
}

.clickable-image {
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content-exp {
  background: white;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: #0E0000;
}

.modal-header-exp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 0 1rem;
}

.modal-title {
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #333;
}

.modal-body-exp {
  padding: 10px 1rem 1rem 1rem;
}

.modal-body-exp .address-block {
  margin-top: 1rem;
}

.modal-body-exp .address-block strong {
  display: block;
  margin-bottom: 0.5rem;
}

.clickable-address {
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
}
.exp-card-a {
  text-decoration: underline;
  color: black;
}
</style>
